import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { notification } from "antd";
import { apiRequest } from "util/services";
import { CONSOLE_HOME_PATH } from "util/consoleHome";
import { resolveSettingsHomeNav } from "util/settingsHomeNav";
import {
  isSettingsSidebarKeyVisible,
  resolveVisibleSettingsSidebarKeys,
} from "util/settingsSidebarVisibility";
import Representation from "./Representation";

const ADMIN_CACHE_KEY = (uid) => `pivony_isAdmin_${uid}`;
const TEAM_ADMIN_CACHE_KEY = (uid) => `pivony_canManageTeams_${uid}`;
const ENTERPRISE_POWER_USER_CACHE_KEY = (uid) => `pivony_isEnterprisePowerUser_${uid}`;

const SettingsLayout = ({ authenticated, user, ...props }) => {
  const history = useHistory();

  const [isAdmin, setIsAdmin] = useState(
    () => localStorage.getItem(ADMIN_CACHE_KEY(user?.uid)) === "true"
  );
  const [canManageTeams, setCanManageTeams] = useState(
    () => localStorage.getItem(TEAM_ADMIN_CACHE_KEY(user?.uid)) === "true"
  );
  const [isEnterprisePowerUser, setIsEnterprisePowerUser] = useState(
    () => localStorage.getItem(ENTERPRISE_POWER_USER_CACHE_KEY(user?.uid)) === "true"
  );
  const [subscriptionRow, setSubscriptionRow] = useState(null);
  const [subscriptionReady, setSubscriptionReady] = useState(false);

  const onChange = (val) => {
    if (val === "home") {
      const { href } = resolveSettingsHomeNav({
        user,
        subscriptionRow,
      });
      history.push(href || CONSOLE_HOME_PATH);
    } else {
      history.push(`/settings/${val}`);
    }
  };
  const selected = (window.location.pathname.split("/settings/")[1] || "").split("?")[0];

  useEffect(() => {
    if (!user?.uid) return;
    apiRequest("subscriptions/all", "POST", { user_id: user.uid }, true).then(
      (result) => {
        if (!result.error) {
          const row = result[0] || null;
          const admin = Boolean(row?.IsOrganizationAdmin);
          const manageTeams = Boolean(row?.CanManageOrganizationTeams);
          const enterprisePowerUser = Boolean(
            row?.IsEnterprisePowerUser ?? row?.IsPowerUser
          );
          setSubscriptionRow(row);
          setIsAdmin(admin);
          setCanManageTeams(manageTeams);
          setIsEnterprisePowerUser(enterprisePowerUser);
          localStorage.setItem(ADMIN_CACHE_KEY(user.uid), String(admin));
          localStorage.setItem(TEAM_ADMIN_CACHE_KEY(user.uid), String(manageTeams));
          localStorage.setItem(
            ENTERPRISE_POWER_USER_CACHE_KEY(user.uid),
            String(enterprisePowerUser)
          );
        } else {
          notification.error({ message: result.error });
        }
        setSubscriptionReady(true);
      }
    );
  }, [user]);

  useEffect(() => {
    if (!subscriptionReady || !selected) return;
    const ctx = {
      plan: user?.plan,
      isAdmin,
      canManageTeams,
      isEnterprisePowerUser,
      subscriptionRow,
    };
    if (isSettingsSidebarKeyVisible(selected, ctx)) return;
    const fallback = resolveVisibleSettingsSidebarKeys(ctx).includes("details")
      ? "details"
      : "home";
    if (fallback === "home") {
      history.replace(CONSOLE_HOME_PATH);
    } else {
      history.replace(`/settings/${fallback}`);
    }
  }, [
    subscriptionReady,
    selected,
    user?.plan,
    isAdmin,
    canManageTeams,
    isEnterprisePowerUser,
    subscriptionRow,
    history,
  ]);

  return (
    <Representation
      onChange={onChange}
      selected={selected}
      history={history}
      isAdmin={isAdmin}
      canManageTeams={canManageTeams}
      isEnterprisePowerUser={isEnterprisePowerUser}
      plan={user.plan}
      user={user}
      subscriptionRow={subscriptionRow}
      {...props}
    />
  );
};

export default SettingsLayout;
